import styled from '@emotion/styled';
import rem from '../../utils/rem/rem';

export const Container = styled.div`
    font-family: 'Open Sans';
`;

export const ImageWrapper =  styled.div`
    width: 128px;
    height: 128px;
`;

export const SolidImageWrapper =  styled.div`
    width: 128px;
    height: 128px;
    background-color: #f7f7f7;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const ImageMessage = styled.div`
    font-family: 'Open Sans';
    font-size: ${rem(13)};
    font-weight: 700;
    color: ${({ theme }) => theme.colors.gray500};
`;